import * as React from 'react';
import cn from 'clsx';

import ico from './arrow.svg';
import * as styles from './styles.css';

interface ITitleIconProps {
  changeValue: string;
  testId: string;
  rotateIcon?: boolean;
}

export const TitleChange: React.FC<ITitleIconProps> = props => {
  const { changeValue, rotateIcon, testId } = props;

  return (
    <span className={styles['text']}>
      <img
        src={ico}
        className={cn(styles['icon'], { [styles['rotate_icon']]: rotateIcon })}
        alt=""
        data-testid={testId}
      />
      {changeValue}
    </span>
  );
};

TitleChange.displayName = 'TitleChange';
